import { render, staticRenderFns } from "./CommentsCard.vue?vue&type=template&id=f6335260&"
import script from "./CommentsCard.vue?vue&type=script&lang=js&"
export * from "./CommentsCard.vue?vue&type=script&lang=js&"
import style0 from "./CommentsCard.vue?vue&type=style&index=0&id=f6335260&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports